import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import AdminApp from "@/admin/AdminApp";
import Layout from "@/components/site/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import { SiteProvider } from "@/lib/SiteContext";
import CMSPage from "@/pages/CMSPage";
import CollectionDetailPage from "@/pages/CollectionDetailPage";
import ContactPage from "@/pages/ContactPage";
import MedicalLaboratoryPage from "@/pages/MedicalLaboratoryPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import RequestQuotePage from "@/pages/RequestQuotePage";

const SERVICES = [
  "quality-inspection",
  "quality-assurance-quality-control",
  "conformity-assessment-support",
  "logistics-management",
  "supply-chain-solutions",
  "medical-laboratory-equipment-supply",
];
const INDUSTRIES = [
  "import-export",
  "manufacturing",
  "healthcare-laboratories",
  "food-consumer-goods",
  "construction-infrastructure",
  "energy-industrial-operations",
  "agriculture-agribusiness",
  "humanitarian-development",
  "government-public-institutions",
  "wholesale-distribution",
  "education-research",
];

function withLayout(el) {
  return <Layout>{el}</Layout>;
}

export default function App() {
  return (
    <HelmetProvider>
      <SiteProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin routes — no marketing shell */}
            <Route path="/admin/*" element={<AdminApp />} />

            {/* Home */}
            <Route path="/" element={withLayout(<CMSPage slug="home" />)} />

            {/* About group */}
            <Route path="/about" element={withLayout(<CMSPage slug="about" banner="page" />)} />
            <Route path="/values" element={withLayout(<CMSPage slug="values" banner="page" />)} />
            <Route path="/how-we-work" element={withLayout(<CMSPage slug="how-we-work" banner="page" />)} />
            <Route path="/why-choose-us" element={withLayout(<CMSPage slug="why-choose-us" banner="page" />)} />

            {/* Services — index + 6 details */}
            <Route path="/services" element={withLayout(<CMSPage slug="services" banner="page" />)} />
            {SERVICES.map((slug) => (
              <Route
                key={slug}
                path={`/services/${slug}`}
                element={withLayout(<CollectionDetailPage kind="service" slug={slug} />)}
              />
            ))}

            {/* Industries — index + 11 details */}
            <Route path="/industries" element={withLayout(<CMSPage slug="industries" banner="page" />)} />
            {INDUSTRIES.map((slug) => (
              <Route
                key={slug}
                path={`/industries/${slug}`}
                element={withLayout(<CollectionDetailPage kind="industry" slug={slug} />)}
              />
            ))}

            {/* Phase 4 pages — real CMS-driven content */}
            <Route
              path="/quality-compliance"
              element={withLayout(<CMSPage slug="quality-compliance" banner="page" />)}
            />
            <Route path="/resources" element={withLayout(<CMSPage slug="resources" banner="page" />)} />
            <Route path="/news" element={withLayout(<CMSPage slug="news" banner="page" />)} />
            <Route path="/gallery" element={withLayout(<CMSPage slug="gallery" banner="page" />)} />
            <Route path="/contact" element={withLayout(<ContactPage />)} />
            <Route path="/request-a-quote" element={withLayout(<RequestQuotePage />)} />

            {/* Medical Laboratory catalog (replaces Projects in nav) */}
            <Route path="/medical-laboratory" element={withLayout(<MedicalLaboratoryPage />)} />
            <Route path="/medical-laboratory/:slug" element={withLayout(<ProductDetailPage />)} />

            {/* Legal (Phase 4) */}
            <Route
              path="/privacy-policy"
              element={withLayout(<CMSPage slug="privacy-policy" banner="page" />)}
            />
            <Route
              path="/terms-of-use"
              element={withLayout(<CMSPage slug="terms-of-use" banner="page" />)}
            />
            <Route
              path="/cookie-policy"
              element={withLayout(<CMSPage slug="cookie-policy" banner="page" />)}
            />

            {/* 404 */}
            <Route path="*" element={withLayout(<NotFoundPage />)} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </HelmetProvider>
  );
}
